import React from 'react';
import './intro.css';
import bg from '../../assets/image.jpg';
import btnImg from '../../assets/bulb.png';
import { Link } from 'react-scroll';

const Intro = () => {
  return (
    <section id="intro">
      <div className="introContent">
        <span className="hello">Hey there!</span>
        <span className="introText">I'm <span className="introName">Praneel</span> <br />SWE / Data Scientist</span>
        <p className="introPara">I'm <span className="hungry">hungry</span> to learn software engineering and artificial intelligence.</p>
        <Link activeClass='active' to='portfolio' spy={true} smooth={true} offset={0} duration={500}><button className="introBtn"><img src={btnImg} alt="View Projects" className="btnImg" />See what I've been <span className="space">.</span><span className="munch">munching</span> <span className="space">.</span>  working on</button></Link>
      </div>
      <img src={bg} alt="Profile" className="bg" />
    </section>
  )
}

export default Intro
